import React, { useEffect, useRef } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import { useSelector } from 'react-redux'

import { useIsAgentChatEnabled } from '~/hooks/useIsAgentChatEnabled'
import { getCurrentUserId } from '~/store/reducers/auth'
import { trackEventOnceDaily, TrackingEvent } from '~/utils/trackingProvider'

import { ChatMode, useAgentChat } from './AgentChatContext'
import AgentChatPanel from './AgentChatPanel'
import AgentFloatingButton from './AgentFloatingButton'
import FloatingChatWindow from './FloatingChatWindow'

const AgentChatManager = () => {
  const { isChatOpen, closeChat, chatMode } = useAgentChat()
  const isAgentChatEnabled = useIsAgentChatEnabled()
  const currentUserId = useSelector(getCurrentUserId)
  const hasTrackedRef = useRef(false)

  // Track adoption rate denominator: users who have ability to use AI assistant
  // Only track once per user per day to avoid event spam
  useEffect(() => {
    if (!isAgentChatEnabled || !currentUserId || hasTrackedRef.current) {
      return
    }

    trackEventOnceDaily(TrackingEvent.AI_ASSISTANT_AVAILABLE, {
      user_id: currentUserId,
    })
    hasTrackedRef.current = true
  }, [isAgentChatEnabled, currentUserId])

  if (!isAgentChatEnabled) {
    return null
  }

  return (
    <ErrorBoundary
      fallback={<></>}
      onError={(error, errorInfo) => {
        // eslint-disable-next-line no-console
        console.error('Agent Chat Error:', error, errorInfo)
      }}
    >
      {isChatOpen && chatMode === ChatMode.RAIL && (
        <AgentChatPanel closeChat={closeChat} />
      )}
      {isChatOpen && chatMode === ChatMode.FLOATING && <FloatingChatWindow />}
      <AgentFloatingButton />
    </ErrorBoundary>
  )
}

export default AgentChatManager
